/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
import React, { lazy, Suspense, useContext, useEffect } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import withAdminLayout from '../../layout/withAdminLayout';
import { UserAuthenticationContext } from '../../config/auth/token_provider';

const Dashboard = lazy(() => import('../../container/dashboard/Ecommerce'));
const ProcessingPayment = lazy(() => import('../../container/pages/Processing-Payment'));
const Home = lazy(() => import('../../container/dashboard/overview/Home/Home'));
const Project = lazy(() => import('../../container/dashboard/overview/project/Project'));
const ProjectDetails = lazy(() => import('../../container/dashboard/overview/project/ProjectDetails'));
const ProjectCreate = lazy(() => import('../../container/dashboard/overview/project/ProjectCreate'));
const ReportData = lazy(() => import('../../container/dashboard/overview/project/overview/DAAS-Report-V1/Grid'));
const FAQ = lazy(() => import('../../container/dashboard/overview/FAQ/FAQ'));
const Workspace = lazy(() => import('../../container/dashboard/overview/Workspace/Workspace'));
const ChatAssistant = lazy(() => import('../../container/dashboard/overview/Chat-Assistant/ChatAssistant'));
const Settings = lazy(() => import('../../container/profile/settings/Settings'));
const DataDashboardUpdated = lazy(() => import('../../container/dashboard/overview/Data-Dashboard/DataDashboard'));

const DashboardRoutes = () => {
  const { user, session } = useContext(UserAuthenticationContext);
  const history = useHistory();

  const routeToDefaultFeature = () => {
    let defaultFeature = session.default_feature;
    switch (defaultFeature) {
      case 'Home':
        history.push('/');
        break;
      case 'Co-Analyst':
        history.push('/chat-assistant');
        break;
      case 'Data Dashboard':
        history.push('/data-dashboard');
        break;
      case 'DAAS':
        history.push('/daas/dashboard');
        break;
      default:
        history.push('/');
        break;
    }
  };

  useEffect(() => {
    routeToDefaultFeature();
  }, []);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <PulseLoader color="#4285f4" loading size={15} aria-label="Loading Spinner" data-testid="loader" />
        </div>
      }
    >
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/dashboard" exact component={Dashboard} />
        <Route path="/dashboard/research" component={Dashboard} />
        <Route path="/provisioning" component={ProcessingPayment} />
        <Route path="/projectDetails/:id" component={ProjectDetails} />
        <Route path="/daas" component={Project} />
        <Route path="/faq" component={FAQ} />
        <Route path="/report" component={ReportData} />
        <Route path="/create" component={ProjectCreate} />
        <Route path="/data-dashboard" component={Workspace} />
        <Route path="/data-dashboard-updated" component={DataDashboardUpdated} />
        <Route path="/chat-assistant" component={ChatAssistant} />
        <Route path="/profile-settings" component={Settings} />
        <Redirect to="/" />
      </Switch>
    </Suspense>
  );
};

export default withAdminLayout(DashboardRoutes);
